// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CheckoutDTO } from '../models';
/**
 * TenancyCheckoutsApi - axios parameter creator
 * @export
 */
export const TenancyCheckoutsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a Checkout for a Tenancy
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckout(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling createCheckout.');
            }
            const localVarPath = `/v2/tenancies/{id}/checkout`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenancyCheckoutsApi - functional programming interface
 * @export
 */
export const TenancyCheckoutsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create a Checkout for a Tenancy
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckout(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckoutDTO> {
            const localVarAxiosArgs = TenancyCheckoutsApiAxiosParamCreator(configuration).createCheckout(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TenancyCheckoutsApi - factory interface
 * @export
 */
export const TenancyCheckoutsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Create a Checkout for a Tenancy
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckout(id: string, options?: any) {
            return TenancyCheckoutsApiFp(configuration).createCheckout(id, options)(axios, basePath);
        },
    };
};

/**
 * TenancyCheckoutsApi - interface
 * @export
 * @interface TenancyCheckoutsApi
 */
export interface TenancyCheckoutsApiInterface {
    /**
     * Create a Checkout for a Tenancy
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyCheckoutsApiInterface
     */
    createCheckout(id: string, options?: any): AxiosPromise<CheckoutDTO>;

}

/**
 * TenancyCheckoutsApi - object-oriented interface
 * @export
 * @class TenancyCheckoutsApi
 * @extends {BaseAPI}
 */
export class TenancyCheckoutsApi extends BaseAPI implements TenancyCheckoutsApiInterface {
    /**
     * Create a Checkout for a Tenancy
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyCheckoutsApi
     */
    public createCheckout(id: string, options?: any) {
        return TenancyCheckoutsApiFp(this.configuration).createCheckout(id, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for TenancyCheckoutsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Create a Checkout for a Tenancy
 * @param {string} id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createCheckout(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<CheckoutDTO> {
    const localVarAxiosArgs = TenancyCheckoutsApiAxiosParamCreator(configuration).createCheckout(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

